module.exports = __webpack_public_path__ + "media/images/icons/outlined/radius-upright-98392c0f065e848db08c338b7f056d97.svg";